import { StyleSheet } from 'aphrodite/no-important';

const LIGHT_GREY = '#a0aabf';
const MED_BLACK = '#666';
const BORDER_DARK = '#999';

let styles = {
  list: {
    display: 'none',
    zIndex: 1,
    right: '45px',
    width: '220px',
    position: 'absolute',
    top: '35px',
    backgroundColor: LIGHT_GREY,
    minHeight: '100px',
    overflowY: 'auto',
    overflowX: 'hidden',
    opacity: 0.85,
    border: '2px solid '.concat(MED_BLACK),
    borderRadius: '5px 5px'
  },
  item: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    padding: '5px 0 5px 0',
    color: MED_BLACK,
    height: '40px',
    cursor: 'pointer',
    textAlign: 'center',
    width: '100%',
    ':nth-child(n)':{
      flex: 1,
      border: 'solid '.concat(BORDER_DARK),
      borderWidth: '0 0 1px 0'
    },
    ':nth-child(last)':{
      borderWidth: 0
    }
  },
  itemhover: {
    ':hover':{
      backgroundColor: 'yellow'
    }
  },
  itemactive:{ 
    backgroundColor: 'lightblue',
    ':active':{
      backgroundColor: 'lightblue'
    }
  }
}

export default StyleSheet.create(styles);


// WEBPACK FOOTER //
// ./src/components/data/historymap/EventList.styles.js